// extracted by mini-css-extract-plugin
export default {"map":"TestLeaflet_map__KgeQ7"};